// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"bf8e1f10","840":"f578f0aa"}[chunkId] + ".chunk.js";
};